// extracted by mini-css-extract-plugin
export default {"waves":"Waves_waves__oA5WJ","bar":"Waves_bar__Ly0kN","equalize":"Waves_equalize__byuDB"};